import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./routes";
import "./index.css";
import { checkConsentOnLoad } from "./lib/analytics";

// Initialize GA only if user previously consented (client-side only)
if (typeof window !== "undefined") {
  checkConsentOnLoad();
}

export const createRoot = ViteReactSSG({ routes });
